import React from 'react';
import { Link } from 'react-router-dom';
import { useInView } from 'react-intersection-observer';
import '../styles/components/Neden.scss';

const Neden = () => {
    const { ref, inView } = useInView({
        threshold: 0.2,
        triggerOnce: true
    });

    return (
        <section id="neden-combined" className="neden-section gradient-bg combined-section">
            <div className="section-container" ref={ref}>
                <h2 className={`section-title ${inView ? 'fade-in' : ''}`}>
                    {/* NEDEN */}
                </h2>

                <div className="community-info stylish-box">
                            <h3>Topluluğumuz bünyesinde</h3>
                            <ul className="decorated-list">
                                <li><span className="gold-text">▦ KAFES ▦ </span> - Try Hard</li>
                                {/* <li><span className="gold-text">▽ KAOS ▽</span> - No Rules</li> */}
                            </ul>
                            <p>sunucusunu topluluğumuza kazandırdık.</p>
                            <p>Sunucumuzda kaliteli bir oyun deneyimi sunarken, topluluk kültürümüzü ve etik değerlerimizi koruyoruz.</p>
                        </div>

                <div className={`neden-content ${inView ? 'slide-up' : ''}`}>
                    <div className="neden-text">
                        <div className="neden-header">
                            <h3>Black owLs sadece bir takım değil, aynı zamanda bir vizyonun temsilcisidir.</h3>
                        </div>

                        <div className="neden-features">



                            <div className="neden-feature">
                                <div className="feature-icon red-logo">
                                    <img src="/assets/images/LogoKirmizi.png" alt="Vision" />
                                </div>
                                <div className="feature-content">
                                    <p>
                                        2018 senesinden beri gayemiz, sadece Türk oyunculardan oluşan bir kadroyla uluslararası arenada bir numara olmak.
                                    </p>
                                    <p>
                                        Buna en yakın başarımız 2020 yılındaki OISC yarı finalleri.
                                    </p>
                                </div>
                            </div>

                            <div className="neden-feature">
                                <div className="feature-icon green-logo">
                                    <img src="/assets/images/LogoSar.png" alt="Success" />
                                </div>
                                <div className="feature-content">
                                    <h4>Ekibimiz, competitive arenada başarı, disiplin ve takım ruhuyla esas alır.</h4>
                                    <p>
                                        Geçmişimizdeki başarılarımız, geleceğimize en düşük hedefler olarak yön vermektedir.
                                    </p>
                                </div>
                            </div>

                            <div className="neden-feature">
                                <div className="feature-icon blue-logo">
                                    <img src="/assets/images/blue_logo.png" alt="Community" />
                                </div>
                                <div className="feature-content">
                                    <p>
                                        Community çatımız altında, içerik üretimi, organizasyon yönetiminin yanında kaliteli ve eğlenceli oyun kültürünü destekliyoruz.
                                    </p>
                                    <p>
                                        Oyuncularımızın ve topluluk üyelerimizin yeteneklerini en iyi şekilde geliştirmelerine yardımcı oluyoruz.
                                    </p>
                                </div>
                            </div>


                        </div>

                        <div className="social-media">
                            <h4>Sosyal medyada bizi takip etmek ve daha fazla bilgi edinmek için:</h4>
                            <div className="social-links">
                                <a href="https://www.instagram.com/blackowlsofc/" target="_blank" rel="noopener noreferrer" className="social-link">
                                    @blackowlsofc
                                </a>
                                {/* <Link to="/takimbasvuru" className="social-button">
                                    <span>Topluluğa Katıl</span>
                                    <i className="arrow-icon"></i>
                                </Link> */}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default Neden;